import { useRef } from "react";
import { Link } from "react-router-dom";
import { GameItem } from "./GameItem";

const Arrow = ({ dir, onClick }) => (
  <button
    className={`splide__arrow splide__arrow--${dir}`}
    type="button"
    aria-label={dir === "prev" ? "Precedente" : "Successivo"}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
      <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z" />
    </svg>
  </button>
);

export function Rail({ id, title, url, items }) {
  const track = useRef(null);
  const scroll = (d) => track.current?.scrollBy({ left: d * track.current.clientWidth * 0.8, behavior: "smooth" });
  if (!Array.isArray(items) || items.length === 0) return null;
  return (
    <div className="splide-container" data-testid={`rail-${id}`}>
      <div className="splide-header">
        <p>{title}</p>
        {url && (
          <Link to={url} data-testid={`rail-more-${id}`}>
            Altri {title}
          </Link>
        )}
      </div>
      <div className="splide splide--slide splide--ltr is-active is-initialized">
        <div className="splide__arrows">
          <Arrow dir="prev" onClick={() => scroll(-1)} />
          <Arrow dir="next" onClick={() => scroll(1)} />
        </div>
        <div className="splide__track" ref={track}>
          <ul className="splide__list gameList">
            {items.map((g) => (
              <GameItem key={g.slug} g={g} slider />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
